import {Injectable} from '@angular/core';
import {BaseEndpoint} from "../../../../base/endpoints/base.endpoint";
import {environment} from "../../../../../environments/environment";
import {IParams} from "../../../../base/endpoints/iparams";

@Injectable({
  providedIn: 'root'
})
export class SocialEndpoint extends BaseEndpoint {

  constructor() {
    super();
  }

  static NOTIFICATIONS = {
    CREATE(): string {
      return environment.base_url + '/api/v1/notifications'
    },
    GET(id: number): string {
      return environment.base_url + '/api/v1/notifications/' + id
    },
    UPDATE(id: number): string {
      return environment.base_url + '/api/v1/notifications/' + id
    },
    COUNT_UNREAD(params: IParams): string {
      return environment.base_url + '/api/v1/notifications/unread/count'
        + BaseEndpoint.toParamString(params)
    },
    INCREASE_VIEW_COUNT(id: number): string {
      return environment.base_url + '/api/v1/notifications/view/count/' + id
    },
    INCREASE_CLICK_COUNT(id: number): string {
      return environment.base_url + '/api/v1/notifications/click/count/' + id
    },
    MARK_READ(params: IParams): string {
      return environment.base_url + '/api/v1/notifications/mark-read'
        + BaseEndpoint.toParamString(params)
    },
    MAKE_STICKY(params: IParams): string {
      return environment.base_url + '/api/v1/notifications/make-sticky'
        + BaseEndpoint.toParamString(params)
    },
    PUBLISH(id: number, published: boolean): string {
      return environment.base_url + '/api/v1/notifications/' + id + '/publish'
        + BaseEndpoint.toParamString({published: published})
    },
    RESPOND(id: number): string {
      return environment.base_url + '/api/v1/notifications/' + id + '/respond'
    },
    NOTIFY(id: number, params: IParams): string {
      return environment.base_url + '/api/v1/notifications/' + id + '/notify'
        + BaseEndpoint.toParamString(params)
    },
    FETCH_MY_NOTIFICATIONS(params: IParams): string {
      return environment.base_url + '/api/v1/my-notifications'
        + BaseEndpoint.toParamString(params)
    },
    SEARCH(params: IParams): string {
      return environment.base_url + '/api/v1/notifications'
        + BaseEndpoint.toParamString(params)
    }
  }

}
